import { itineraryApprovalClientService, } from "../services/itinerary-approval-client.service";
function approvalPath(itineraryId, approvalId) {
    return `/api/v2/itineraries/${encodeURIComponent(itineraryId)}/approvals/${encodeURIComponent(approvalId)}`;
}
export async function fetchItineraryApproval(itineraryId, approvalId, accessGrant) {
    return itineraryApprovalClientService.request({
        path: approvalPath(itineraryId, approvalId),
        accessGrant,
    });
}
export async function decideItineraryApproval(itineraryId, approvalId, accessGrant, input) {
    return itineraryApprovalClientService.request({
        path: approvalPath(itineraryId, approvalId),
        accessGrant,
        method: "PATCH",
        body: {
            state: input.state,
            version: input.version,
            reason: input.reason || undefined,
        },
    });
}
export async function createItineraryPaymentRequest(itineraryId, approvalId, accessGrant) {
    return itineraryApprovalClientService.request({
        path: `${approvalPath(itineraryId, approvalId)}/payment-requests`,
        accessGrant,
        method: "POST",
    });
}
export async function createFileDownload(fileId, accessGrant) {
    return itineraryApprovalClientService.request({
        path: `/api/v2/files/${encodeURIComponent(fileId)}/downloads`,
        accessGrant,
        method: "POST",
    });
}
